export default "<div class=\"footer\">Copyright © 2020 Dunsandel Historic Society. All rights reserved. Website created and maintained by Steven Little</div>"